<div class="comp-header__queries">
  <adm-text-search [placeholder]="'Søg lokationer'" (search$)="onSearchInput($event)" [searchText]="searchText() ?? ''" />

  @if (!isHidden('organization')) {
    <adm-org-typeahead
      [initialId]="organizationId() ?? undefined"
      [resetTrigger]="resetTrigger()"
      (itemSelected)="onOrganizationSelected($event)" />
  }

  @if (!isHidden('department')) {
    <adm-dep-typeahead
      [itemTemplate]="departmentDropdownItemTemplate"
      [organizationId]="organizationId()"
      [departmentId]="departmentId()?.toString() ?? null"
      (itemSelected)="onDepartmentSelected($event)"
      [resetTrigger]="resetTrigger()" />
  }
  <ng-template #departmentDropdownItemTemplate let-department>
    <div class="typeahead-item">
      <strong class="icon-with-text">
        {{ department.name }}
      </strong>
      <span>{{ department.organizationName }}</span>
    </div>
  </ng-template>

  @if (!isHidden('access-group')) {
    <adm-access-group-typeahead
      [itemTemplate]="accessGroupDropdownItemTemplate"
      [accessGroupId]="accessGroupIdentifier()?.toString() ?? null"
      [organizationId]="organizationId()"
      (itemSelected)="onAccessGroupSelected($event)"
      [resetTrigger]="resetTrigger()" />
  }
  <ng-template #accessGroupDropdownItemTemplate let-accessGroup>
    <div class="typeahead-item">
      <strong class="icon-with-text">
        {{ accessGroup.name }}
      </strong>
      <span>{{ accessGroup.organizationName }}</span>
    </div>
  </ng-template>

  @if (isPricePolicyViewer() && !isHidden('price-policy')) {
    <adm-adm-price-policy-typeahead
      [initialPricePolicyId]="pricePolicyId()?.toString() ?? null"
      [organizationId]="organizationId()"
      (itemSelected)="onPricePolicySelected($event)"
      [resetTrigger]="resetTrigger()" />
  }

  @if (!isHidden('errors-only')) {
    <div class="comp-header__filter-checkbox">
      <mat-checkbox
        [checked]="locationsWithErrorsInSetup()"
        (change)="updateLocationWithErrorFilter($event.checked)"
        [matTooltip]="'Vis kun lokationer med fejl i opsætning'">
        Kun lokationer med fejl
      </mat-checkbox>
    </div>
  }

  <button class="comp-header__reset-button" (click)="onResetAllFilters()" mat-stroked-button>Nulstil</button>
</div>
